(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hatitude-idea-workshop"] && !Shopify.designMode) return;
  try {
    
async function loadHatitudeLatest(root){
  if(root.dataset.loaded)return;
  root.dataset.loaded='true';
  const select=name=>root.querySelector('[data-idea-'+name+']');
  const feedback=select('feedback');
  const controller=new AbortController();
  const timer=setTimeout(()=>controller.abort(),8000);
  try{
    const response=await fetch('/apps/ideverkstad/api/ideas?sort=new',{credentials:'same-origin',cache:'no-store',signal:controller.signal});
    if(!response.ok)throw new Error('Ideas unavailable');
    const data=await response.json();
    if(!Array.isArray(data.ideas))throw new Error('Invalid ideas');
    const idea=data.ideas[0];
    if(!idea){feedback.textContent=select('empty').textContent;return;}
    const card=select('card');
    select('title').textContent=String(idea.title||'');
    const excerpt=String(idea.description||'').replace(/\s+/g,' ').trim();
    select('excerpt').textContent=excerpt.length>180?excerpt.slice(0,180).trimEnd()+'…':excerpt;
    select('author').textContent=String(idea.display_name||'Hatitudist');
    select('author').classList.toggle('hi-official',idea.official===true);
    const category=select('category-'+idea.category);
    select('category').textContent=(category||select('category-other')).textContent;
    const status=select('status-'+idea.status);
    select('status').textContent=status?status.textContent:'';
    let imageUrl=null;
    if(Array.isArray(idea.images)&&idea.images[0]?.url){
      const url=new URL(idea.images[0].url,location.origin);
      if(url.protocol==='https:'&&(url.origin===location.origin||url.hostname==='hatitude-ideverkstad.houseofhatitude.workers.dev'))imageUrl=url.href;
    }
    if(imageUrl){
      const image=select('image');image.src=imageUrl;image.alt=String(idea.title||'');
      image.addEventListener('error',()=>{select('image-link').hidden=true;card.classList.add('hi-no-image');},{once:true});
      select('image-link').hidden=false;
    }else card.classList.add('hi-no-image');
    card.hidden=false;feedback.hidden=true;
  }catch(error){feedback.textContent=select('error').textContent;}
  finally{clearTimeout(timer);}
}
function setupHatitudeLatest(){document.querySelectorAll('[data-idea-workshop]').forEach(loadHatitudeLatest);}
setupHatitudeLatest();
document.addEventListener('shopify:section:load',setupHatitudeLatest);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hatitude-revolt-header"]) return;
  try {
    
function setupHatitudeMegaMenus(){
  document.querySelectorAll('.rv-mega').forEach(menu=>{
    if(menu.dataset.ready)return;
    menu.dataset.ready='true';
    const toggle=menu.querySelector(':scope > summary');
    const close=()=>{menu.open=false;toggle.focus();};
    menu.querySelector('.rv-mega-close').addEventListener('click',close);
    menu.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu.open){event.preventDefault();close();}});
    menu.addEventListener('toggle',()=>{toggle.setAttribute('aria-expanded',String(menu.open));});
    toggle.setAttribute('aria-expanded',String(menu.open));
    document.addEventListener('click',event=>{if(menu.open&&!menu.contains(event.target))menu.open=false;});
  });
}
function setupHatitudeCart(){
  document.querySelectorAll('#main > div').forEach(element=>{
    if(!element.classList.contains('no-inert'))element.setAttribute('data-js-inert','');
  });
  window.inertElems=document.querySelectorAll('[data-js-inert]');
  document.querySelectorAll('.rv-cart-toggle').forEach(toggle=>{
    if(toggle.dataset.ready)return;
    toggle.dataset.ready='true';
    toggle.addEventListener('click',event=>{
      const drawer=document.getElementById('site-cart-sidebar');
      if(!drawer)return;
      event.preventDefault();
      customElements.whenDefined('sidebar-drawer').then(()=>{
        document.querySelectorAll('#main > div').forEach(element=>{
          if(!element.classList.contains('no-inert'))element.setAttribute('data-js-inert','');
        });
        window.inertElems=document.querySelectorAll('[data-js-inert]');
        toggle.setAttribute('aria-expanded','true');
        drawer.show();
        drawer.querySelector('[data-js-close]')?.focus();
      });
    });
  });
  const overlay=document.querySelector('.site-overlay');
  if(overlay&&!overlay.dataset.hatitudeReady){
    overlay.dataset.hatitudeReady='true';
    overlay.addEventListener('click',()=>{
      const drawer=document.getElementById('site-cart-sidebar');
      if(drawer?.classList.contains('sidebar--opened')){
        drawer.hide();
        document.querySelector('.rv-cart-toggle')?.focus();
      }
    });
  }
}
setupHatitudeMegaMenus();
setupHatitudeCart();
document.addEventListener('shopify:section:load',()=>{setupHatitudeMegaMenus();setupHatitudeCart();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hatitude-season-popup"] && !Shopify.designMode) return;
  try {
    
function setupHatitudeSeasonPopup(){
  document.querySelectorAll('[data-season-popup]').forEach(dialog=>{
    if(dialog.dataset.ready)return;
    dialog.dataset.ready='true';
    if(typeof dialog.showModal!=='function')return;
    const key='hatitude-season-2026-27';
    const editor=Boolean(window.Shopify&&window.Shopify.designMode);
    let seen=false,timer,previousFocus,attempts=0;
    try{seen=sessionStorage.getItem(key)==='seen';}catch{}
    if((seen&&!editor)||Date.now()>=Date.parse(dialog.dataset.until))return;
    const close=()=>{if(dialog.open)dialog.close();};
    dialog.querySelectorAll('[data-season-close]').forEach(button=>button.addEventListener('click',close));
    dialog.querySelector('[data-season-cta]').addEventListener('click',close);
    dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();});
    dialog.addEventListener('close',()=>{document.documentElement.classList.remove('hs-season-lock');if(previousFocus&&previousFocus.isConnected)previousFocus.focus({preventScroll:true});});
    const show=()=>{
      if(!dialog.isConnected||Date.now()>=Date.parse(dialog.dataset.until))return;
      const occupied=[...document.querySelectorAll('dialog[open],[role="dialog"],.sidebar--opened')].some(el=>el!==dialog&&el.getClientRects().length&&getComputedStyle(el).visibility!=='hidden');
      if(occupied){if(++attempts<30)timer=setTimeout(show,1000);return;}
      previousFocus=document.activeElement;
      dialog.showModal();
      document.documentElement.classList.add('hs-season-lock');
      try{sessionStorage.setItem(key,'seen');}catch{}
    };
    timer=setTimeout(show,Number(dialog.dataset.delay)||3000);
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(dialog)){clearTimeout(timer);close();}});
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupHatitudeSeasonPopup,{once:true});else setupHatitudeSeasonPopup();
document.addEventListener('shopify:section:load',setupHatitudeSeasonPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hatitude-winter-edit"] && !Shopify.designMode) return;
  try {
    
function setupWinterFilms(){
document.querySelectorAll('video[data-wc-film]').forEach(video=>{
if(video.dataset.wcReady)return;
video.dataset.wcReady='true';
const container=video.closest('section');
const button=container.querySelector('[data-wc-control]');
const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
const canAuto=()=>!reduce.matches&&!navigator.connection?.saveData;
let userPaused=false,visible=false;
const updateButton=()=>{if(!button)return;button.textContent=video.paused?button.dataset.play:button.dataset.pause;button.setAttribute('aria-pressed',String(!video.paused));};
const load=()=>{const source=video.querySelector('source');if(!source.src){source.src=window.matchMedia('(max-width:700px)').matches&&source.dataset.mobileSrc?source.dataset.mobileSrc:source.dataset.src;video.load();}};
const play=()=>{load();video.muted=true;video.play().then(updateButton).catch(updateButton);};
video.addEventListener('playing',()=>{video.classList.add('wc-film-ready');updateButton();});
video.addEventListener('pause',updateButton);
video.addEventListener('error',()=>{video.classList.remove('wc-film-ready');updateButton();});
if(button)button.addEventListener('click',()=>{if(video.paused){userPaused=false;play();}else{userPaused=true;video.pause();}});
const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible&&canAuto()&&!userPaused)play();else video.pause();},{threshold:.2});
observer.observe(video);
reduce.addEventListener('change',()=>{if(reduce.matches)video.pause();else if(visible&&!userPaused)play();});
document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();else if(visible&&canAuto()&&!userPaused)play();});
});
}
setupWinterFilms();
document.addEventListener('shopify:section:load',setupWinterFilms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hatitude-winter"] && !Shopify.designMode) return;
  try {
    
function initWinterVideo(){document.querySelectorAll('[data-winter-video]').forEach(video=>{if(video.dataset.initialized)return;video.dataset.initialized='true';const button=video.closest('.hw-hero').querySelector('[data-winter-toggle]');const update=()=>{video.classList.toggle('is-playing',!video.paused);button.setAttribute('aria-pressed',String(!video.paused));button.textContent=video.paused?button.dataset.play:button.dataset.pause;};button.dataset.play=button.textContent;button.addEventListener('click',()=>{if(video.paused)video.play().catch(()=>{});else video.pause();});video.addEventListener('play',update);video.addEventListener('pause',update);if(!matchMedia('(prefers-reduced-motion: reduce)').matches&&!navigator.connection?.saveData){video.play().catch(()=>{});}document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();});});}initWinterVideo();document.addEventListener('shopify:section:load',initWinterVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hatitude-worker"] && !Shopify.designMode) return;
  try {
    
function initializeWorkerForms() {
  document.querySelectorAll('.hwk-form').forEach((form) => {
    if (form.dataset.workerInitialized) return;
    form.dataset.workerInitialized = 'true';
    const category = form.querySelector('select[name="contact[product_type]"]');
    const updateQuantities = () => {
      const both = category.value === 'Både kepsar och mössor';
      form.querySelectorAll('[data-worker-quantity]').forEach((wrapper) => {
        const active = both || (wrapper.dataset.workerQuantity === 'caps' && category.value === 'Kepsar') || (wrapper.dataset.workerQuantity === 'beanies' && category.value === 'Mössor');
        wrapper.hidden = !active;
        const input = wrapper.querySelector('input');
        input.disabled = !active;
        input.required = active;
      });
    };
    category.addEventListener('change', updateQuantities);
    updateQuantities();
  });
}
initializeWorkerForms();
document.addEventListener('shopify:section:load', initializeWorkerForms);

  } catch(e) { console.error(e); }
})();
})();
